import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderMainComponent } from './components/loaders/loader-main/loader-main.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ModalComponent } from './elements/modal/modal.component';
import { IconClearComponent } from './icons/icon-clear/icon-clear.component';
import { IconInfoComponent } from './icons/icon-info/icon-info.component';
import { IconSettingComponent } from './icons/icon-setting/icon-setting.component';
import { IconToggleThemeDarkComponent } from './icons/icon-toggle-theme-dark/icon-toggle-theme-dark.component';
import { IconToggleThemeLightComponent } from './icons/icon-toggle-theme/icon-toggle-theme.component';
import { IconContextEmailComponent } from './icons/icon-context-email/icon-context-email.component';
import { IconContextSelectionComponent } from './icons/icon-context-selection/icon-context-selection.component';
import { IconContextClipboardComponent } from './icons/icon-context-clipboard/icon-context-clipboard.component';
import { IconContextHistoryComponent } from './icons/icon-context-history/icon-context-history.component';
import { IconImgComponent } from './icons/icon-img/icon-img.component';
import { IconCloseSmallComponent } from './icons/icon-close-small/icon-close-small.component';
import { IconLockComponent } from "@shared/icons/icon-lock/icon-lock.component";
import { IconContextDocumentComponent } from "@shared/icons/icon-context-document/icon-context-document.component";
import { TooltipDirective } from "@shared/directives/tooltip.directive";


@NgModule({
    declarations: [
        MainLayoutComponent,
        LoaderMainComponent,
        ModalComponent,
        IconClearComponent,
        IconInfoComponent,
        IconSettingComponent,
        IconToggleThemeDarkComponent,
        IconToggleThemeLightComponent,
        IconContextEmailComponent,
        IconContextSelectionComponent,
        IconContextClipboardComponent,
        IconContextHistoryComponent,
        IconImgComponent,
        IconCloseSmallComponent,
        IconLockComponent,
        IconContextDocumentComponent,
        TooltipDirective,
    ],
    imports: [
        CommonModule,
        TranslateModule,
    ],
    exports: [
        TranslateModule,
        MainLayoutComponent,
        LoaderMainComponent,
        ModalComponent,
        IconClearComponent,
        IconInfoComponent,
        IconSettingComponent,
        IconToggleThemeDarkComponent,
        IconToggleThemeLightComponent,
        IconContextEmailComponent,
        IconContextSelectionComponent,
        IconContextClipboardComponent,
        IconContextHistoryComponent,
        IconImgComponent,
        IconCloseSmallComponent,
        IconLockComponent,
        IconContextDocumentComponent,
        TooltipDirective,
    ]
})
export class SharedModule { }
